import React, { useEffect, useState } from 'react';
import { useModal } from '../../../hooks/useModal';
import useStateControls from '../../../hooks/useStateControls';
import content, { useContent } from '../../../redux/reducer/content';
import { useDispatch } from 'react-redux';
import { loseQuizContent } from '../../../constants/copyright-modals';
import { GTMQuizSuccess } from '../../../constants/analytics/GTM';
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData';
import { useQuizComponents } from '../../../hooks/useQuizComponents';
import QuizComponent from './quizComponent/QuizComponent';
import AppLoader from '../../features/appLoader/AppLoader';

const Quiz = React.forwardRef(function Quiz({ callbacks }, ref) {
  const dispatch = useDispatch();
  const { currentQuiz, currentQuizAnswers } = useContent();
  const { setQuizAnswer, resetQuizAnswers } = content.actions;
  const [activeItem, setActiveId] = useState(0);
  const [isShowScore, setIsShowScore] = useState(false);
  const { addModal } = useModal();
  const { setState } = useStateControls();
  const [buttonId, setButtonId] = useState(null);

  const nextStep = () => {
    if (activeItem < currentQuiz?.questions?.length - 1) {
      setActiveId(activeItem + 1);
      return;
    }

    setIsShowScore(true);
  };

  const reset = () => {
    setIsShowScore(false);
    setActiveId(0);
    dispatch(resetQuizAnswers());
  };

  const goHome = () => (reset(), setState('main'));

  const pause = () =>
    addModal({
      type: 'pauseModal',
      props: { backFunc: () => (reset(), setState('main')) },
    });

  const setScore = (id) => dispatch(setQuizAnswer(id));

  const isPending = useRequestsHandlerData([
    {
      address: 'requestsGameSubmitCurrentQuizResult',
      fulfilled: ({ result }) => {
        const { isWin, money, attempts, score, correct, prize } = result;

        const quizAnswersData = {
          truth: correct,
          wrong: currentQuizAnswers.length - correct,
        };

        isWin && GTMQuizSuccess(currentQuiz.id);

        const modalProps = isWin
          ? {
              title: currentQuiz.title,
              img: currentQuiz?.final_image,
              link: currentQuiz?.button_link,
              points: score,
              coins: money,
              energy: attempts,
              prize: { ...prize },
              rules: { text: currentQuiz?.rules, pdf: currentQuiz?.pdf_rules },
              goHome,
            }
          : {
              ...loseQuizContent,
              quizAnswersData,
              link: currentQuiz?.button_link,
              reset,
              goHome,
            };

        addModal({
          type: isWin ? 'quizWinModal' : 'loseModal',
          props: { ...modalProps, id: currentQuiz.id, callbacks },
        });
      },
    },
  ]);

  useEffect(() => {
    if (isShowScore) callbacks.submitCurrentQuizResult(currentQuizAnswers);
  }, [isShowScore]);

  const component = useQuizComponents({ currentQuiz, activeItem, setScore, nextStep, buttonId, setButtonId });

  return (
    <>
      <QuizComponent
        reference={ref}
        activeItem={activeItem}
        currentQuiz={currentQuiz}
        pause={pause}
        component={component}
        isPending={isPending}
      />
      {isPending && <AppLoader />}
    </>
  );
});

export default Quiz;
Quiz.propTypes = {};
